import * as React from 'react';
import { IConfig } from '@cian/config/shared';

import { IJsonQuery } from '../types/jsonQuery';
import { ISpecialPromo } from '../types/specialPromo';
import { TCurrentLocation } from '../types/location';
import { TModifier } from '../types/modifier';
import { IMakeRequest } from '../../../../shared/utils/request';

export interface IContext {
  jsonQuery: IJsonQuery;
  currentLocation: TCurrentLocation;
  specialPromo?: ISpecialPromo;
  hasUnderground: boolean;
  hasDistricts: boolean;
  hasHighways: boolean;
  appContext: {
    makeRequest: IMakeRequest;
    config: IConfig;
  };
  onChange(...modifiers: [TModifier, ...TModifier[]]): void;
  onApply(): void;
  onClear?(): void;
  onApplyClick?(): void;
  onAdvancedFiltersOpen?(): void;
  onAdvancedFiltersClose?(): void;
  onGeoPopupOpen?(): void;
  onUndergroundPopupOpen?(): void;
  onDistrictPopupOpen?(): void;
  onHighwaysPopupOpen?(): void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// tslint:disable-next-line:no-any
export const context = React.createContext<IContext>(null as any);
